import { lazy } from 'react'

export const BlockLazy = lazy(() =>
    import('./Block').then((component) => ({ default: component.Block }))
)
